import React from "react"
import { connect } from "react-redux"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { resetNewVoucher } from "../reducers/newVoucherReducer"

import Fab from "@mui/material/Fab"
import AddIcon from "@mui/icons-material/Add"

import {blueButton} from "./colorbuttons"

const NewFab = (props) => {
  const history = useHistory()
  const { t } = useTranslation("newFab")

  const newVoucher = () => {
    props.resetNewVoucher()
    history.push("/new")
  }

  if (
    !props.rights.includes("Tl") &&
    !props.rights.includes("Tt") &&
    !props.rights.includes("Kl")
  )
    return null

  return (
    <div style={{ float: "right" }}>
      <Fab
        color="primary"
        variant="extended"
        aria-label="add"
        onClick={newVoucher}
        sx={blueButton}
      >
        <AddIcon /> {t("new")}
      </Fab>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    rights: state.cloud && state.cloud.current && state.cloud.current.rights,
  }
}

export default connect(mapStateToProps, { resetNewVoucher })(NewFab)
